import { withNavBar } from '../../shared/NavBar/NavBar';
import AccountForm from '../../shared/AccountForm/AccountForm';
import './CreateAccount.scss';

const CreateAccount = () => {
  return (
    <div className="profile" >
      <h4 className='create-title'>Create New Account</h4>
      <AccountForm type="create" />
    </div>
  );
};

export default withNavBar(CreateAccount);
